import React from 'react';
import OnBoardingView from './view';

export default function OnBoardingCarrousel() {
  return <OnBoardingView />;
};
